<template>
  <input
    class="kits-input"
		:class="fullWidth ? 'full-width' : ''"
    type="text"
    :value="modelValue"
    @input="onInput"
  />
</template>

<script>
import { props } from "./common";
export default {
  props: props,
  methods: {
    onInput(event) {
      let inputValue = event.target.value;
      // Allow only numbers, commas, dots, and a single leading minus sign
      const validInput = /^-?[0-9.,]*$/;
      if (!validInput.test(inputValue)) {
        // Remove invalid characters while keeping valid ones
        inputValue = inputValue.replace(/[^0-9.,-]/g, '');
        // Ensure the minus sign is only at the start
        inputValue = inputValue.replace(/(?!^)-/g, '');
        event.target.value = inputValue;
      }
      // Replace comma with dot for database storage
      const normalizedValue = inputValue.replace(',', '.');
      const eventTemp = event;
      eventTemp.target.value = normalizedValue;

      this.$emit('input', eventTemp);
      this.$emit('update:modelValue', normalizedValue);
    }
  }
};
</script>
